import { styled, kfrm, css } from '@elliemae/ds-system';

export const Container = styled.header`
  width: auto;
  height: 48px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: ${(props) => props.theme.colors.brand[700]};
  padding: ${(props) => `${props.theme.space.xxs} ${props.theme.space.xs}`};
  color: ${(props) => props.theme.colors.neutral['000']};
`;

const growLeft = kfrm`
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
`;

export const SearchWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.brand[600]};
  ${css`
    animation: ${growLeft} 1s;
  `}
  float: right;
  width: 100%;
  border-radius: 4px;
  .dsInput {
    input {
      border-radius: 2px 0 0 2px;
      color: ${(props) => props.theme.colors.neutral['000']};
      border: calc(0.30769rem * 0.25) solid ${(props) => props.theme.colors.brand[800]} !important;
      &:focus {
        border-right: none !important;
      }
      &::placeholder {
        color: ${(props) => props.theme.colors.neutral['000']};
      }
    }
    .em-ds-input__clearable {
      border: calc(0.30769rem * 0.25) solid ${(props) => props.theme.colors.brand[800]} !important;
    }
  }

  .dsButton {
    border-color: ${(props) => props.theme.colors.brand[800]} !important;
    border-radius: 0 2px 2px 0;
    border-left: none;
  }
  svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.neutral['000']};
  }
`;

export const Icon = styled.div`
  margin-right: ${(props) => props.theme.space.xs};
`;

export const Label = styled.div`
  font-family: ${(props) => props.theme.fonts.default};
  font-weight: ${(props) => props.theme.fontWeights.regular};
  font-size: 25px;
  line-height: 32px;
`;

export const RightSection = styled.div`
  padding-top: 5px;
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: row;
  height: 32px;
  span {
    flex-grow: 1;
  }
`;
